@use "../../../node_modules/@thelabnyc/breakpoint-sass/stylesheets/breakpoint";
@use "../../styles/layout";

$row-height: 40px;

.root {
    height: 100%;
    overflow: hidden;
    max-width: 80vw;
    width: 100%;
}

.viewport {
    height: 100%;
    overflow: hidden;
    position: relative;
}

.track {
    display: flex;
    flex-direction: column;
    width: 100%;
    transition: none;

    &.sliding {
        transform: translateY(-$row-height);
        transition: transform 0.4s ease-in-out;
    }
}

.row {
    background: linear-gradient(
        to right,
        transparent,
        var(--color-monza) 10%,
        var(--color-monza) 90%,
        transparent
    );
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    height: $row-height;
    flex-shrink: 0;
}

.cell {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    aspect-ratio: 1;
    transition: opacity 0.3s ease;
}

.shrimpIcon {
    aspect-ratio: 1/1;
    display: block;
    max-width: 100%;
    max-height: 100%;
}

.dot {
    display: block;
    height: 12px;
    width: 12px;

    @include breakpoint.breakpoint(layout.$belowMedium) {
        height: 8px;
        width: 8px;
    }
}

@media (prefers-reduced-motion: reduce) {
    .track.sliding {
        transition: none;
    }
}
